// @flow strict

import React from 'react';

import { SvgIcon, type SvgIconComponentProps } from './svg-icon';

/**
 * Icon for search.
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const SearchIcon = (props: SvgIconComponentProps) => {
  return (
    <SvgIcon viewBox="0 0 16 16" name="OMQSearchIcon" {...props}>
      <path
        fillRule="evenodd"
        d="M15.119 13.76l-3.027-3.026c1.97-2.635 1.783-6.37-.61-8.764-2.627-2.627-6.886-2.627-9.513 0-2.625 2.626-2.625 6.884 0 9.511 2.395 2.395 6.13 2.581 8.765.611l3.025 3.027c.376.375.984.375 1.36 0 .375-.376.375-.984 0-1.36zm-4.996-3.637c-1.877 1.875-4.919 1.875-6.794 0-1.877-1.877-1.877-4.919 0-6.794 1.875-1.877 4.917-1.877 6.794 0 1.875 1.875 1.875 4.917 0 6.794z"
      />
    </SvgIcon>
  );
};

/**
 * Icon for search, in light gray.
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const SearchLightIcon = (props: SvgIconComponentProps) => {
  return (
    <SvgIcon viewBox="0 0 18 18" name="OMQSearchLightIcon" {...props}>
      <path
        fill="#979797"
        fillRule="evenodd"
        d="M17.672 16.082l-3.538-3.536c2.302-3.08 2.083-7.446-.714-10.243-3.07-3.07-8.048-3.07-11.118 0-3.07 3.069-3.07 8.046 0 11.117 2.798 2.798 7.165 3.016 10.244.714l3.536 3.538c.44.437 1.15.437 1.59 0 .437-.44.437-1.15 0-1.59zm-5.84-4.25c-2.193 2.192-5.749 2.192-7.941 0-2.193-2.194-2.193-5.75 0-7.941 2.192-2.194 5.748-2.194 7.94 0 2.193 2.192 2.193 5.747 0 7.94z"
      />
    </SvgIcon>
  );
};
